import { Button } from "@mui/material";
import PropTypes from "prop-types";
import { forwardRef } from "react";

const MKButton = forwardRef(({ color, variant, size, circular, iconOnly, ...rest }, ref) => (
  <Button
    ref={ref}
    color={color}
    variant={variant === "gradient" ? "contained" : variant}
    size={size}
    sx={{
      borderRadius: circular ? "50%" : "0.5rem",
      minWidth: iconOnly ? "auto" : undefined,
      width: iconOnly ? "2.5rem" : undefined,
      height: iconOnly ? "2.5rem" : undefined,
      padding: iconOnly ? "0.75rem" : undefined,
      ...(variant === "gradient" && color === "primary" && {
        background: "linear-gradient(195deg, #FF8A5B 0%, #FF6B35 100%)",
        boxShadow: "0 4px 20px 0 rgba(0,0,0,0.14), 0 7px 10px -5px rgba(255,107,53,0.4)",
        "&:hover": {
          boxShadow: "0 14px 26px -12px rgba(255,107,53,0.4), 0 4px 23px 0 rgba(0,0,0,0.12), 0 8px 10px -5px rgba(255,107,53,0.2)",
        },
      }),
      ...(variant === "gradient" && color === "info" && {
        background: "linear-gradient(195deg, #6FE4DA 0%, #4ECDC4 100%)",
        boxShadow: "0 4px 20px 0 rgba(0,0,0,0.14), 0 7px 10px -5px rgba(78,205,196,0.4)",
        "&:hover": {
          boxShadow: "0 14px 26px -12px rgba(78,205,196,0.4), 0 4px 23px 0 rgba(0,0,0,0.12), 0 8px 10px -5px rgba(78,205,196,0.2)",
        },
      }),
      ...(variant === "gradient" && color !== "primary" && color !== "info" && {
        background: "linear-gradient(195deg, #49a3f1 0%, #1A73E8 100%)",
        boxShadow: "0 4px 20px 0 rgba(0,0,0,0.14), 0 7px 10px -5px rgba(26,115,232,0.4)",
        "&:hover": {
          boxShadow: "0 14px 26px -12px rgba(26,115,232,0.4), 0 4px 23px 0 rgba(0,0,0,0.12), 0 8px 10px -5px rgba(26,115,232,0.2)",
        },
      }),
      ...rest.sx,
    }}
    {...rest}
  />
));

MKButton.defaultProps = {
  color: "primary",
  variant: "contained",
  size: "medium",
  circular: false,
  iconOnly: false,
};

MKButton.propTypes = {
  color: PropTypes.oneOf([
    "default",
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  variant: PropTypes.oneOf(["text", "contained", "outlined", "gradient"]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  circular: PropTypes.bool,
  iconOnly: PropTypes.bool,
};

MKButton.displayName = "MKButton";

export default MKButton;

